export default __webpack_public_path__ + "static/media/no-events.aabeef57.png";